import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from 'react-bootstrap/Navbar'
import HeaderLogo from '../../assets/images/800home/Logo.webp'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { useLocation } from 'react-router-dom'
import OneNavLink from './OneNavLink'

const MobileHeader = () => {
const location = useLocation()
    const { pathname } = location
    const splitLocation = pathname.split('/')
    const pageName = '/' + splitLocation[1]
    return (
        <>
            <section className="container-fluid bg-ss-secondary" style={{ zIndex: 9999, position: 'relative' }}>
                <Navbar expand="lg" className="">
                    <div className="container-fluid gx-0">
                        <Navbar.Brand className="navbar-brand ms-2 py-2">
                            <Link className="" to="/">
                                <img src={HeaderLogo} alt="Logo" title="Logo" className="header-logo" />
                            </Link>
                        </Navbar.Brand>

                        <Navbar.Toggle
                            aria-controls={`offcanvasNavbar-expand-xl`}
                            className="border-0 rounded-0 toggle-icon bg-white fs-ss-12 py-2 rounded-2"
                        />

                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-xl`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
                            placement="start"
                            className="navbar-offcanvas"
                            style={{ zIndex: 99999 }}
                        >
                            <Offcanvas.Header closeButton className="">
                                <Offcanvas.Title className="" id={`offcanvasNavbarLabel-expand-xl`}>
                                    <Link className="" to="/">
                                        <img src={HeaderLogo} alt="Logo" title="Logo" className="header-logo" />
                                    </Link>
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <ul className="navbar-nav ms-auto">
                                    <OneNavLink NavItem="Why 800 Homes" Link="/why-800-homes" />
                                    <OneNavLink NavItem="Leadership" Link="/leadership/" />
                                    <OneNavLink NavItem="Our Team" Link="/our-team" />
                                    <OneNavLink NavItem="Awards & Achievements" Link="/awards-and-achievements" />
                                    <OneNavLink NavItem="Property Investment" Link="/dubai-property-investment" />
                                    <OneNavLink NavItem="Why Dubai" Link="/why-dubai" />
                                    <OneNavLink NavItem="Buy Property" Link="/properties-for-sale" />
                                    <OneNavLink NavItem="Mortgage Calculator" Link="/mortgage-calculator" />
                                    <OneNavLink NavItem="Sell Property" Link="/sell-property" />
                                     <div className="fw-400 fs-header-link px-md-2 px-lg-3 mx-lg-1 pb-4 pb-md-0">
                                        <a href="https://800homes.ae/blogs/" className={`text-decoration-none text-hover-ss-primary ${pageName === "/blogs" ? "text-ss-primary text-hover-ss-primary" : "text-white"}`}> Blogs </a>     
                                    </div>
                                    <OneNavLink NavItem="Brochures" Link="/brochures" />
                                    <OneNavLink NavItem="FAQs" Link="/faqs" />
                                    <OneNavLink NavItem="Careers" Link="/careers" />
                                    <OneNavLink NavItem="Contact Us" Link="/contact-us" />
                                </ul>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </div>
                </Navbar>
            </section>
        </>
    )
}

export default MobileHeader
